import React from 'react'
import './bpCountSummary.css'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { formateTimeZone } from '../../util_service/timeZoneFormater/timeZoneFormater'
dayjs.extend(utc)

interface BpCountSummaryProps {
    clockIn?: string;
    clockOut?: string;
    workingHours?: string;
    lastAddedDate?: string;
    clockInDate?: string;
    className?: string;
}

const BpCountSummary = (props: BpCountSummaryProps) => {
    const dateItem = props.clockInDate !== undefined
        ? { label: 'Date', value: props.clockInDate || '--' }
        : { label: 'Last Added Date', value: props.lastAddedDate ? dayjs.utc(props.lastAddedDate).format('DD/MM/YYYY') : '--' }

    return (
        <div className={`bp-summary-container ${props.className || ''}`}>
            <div className='bp-summary-item'>
                <label>{dateItem.label}</label>
                <span>{dateItem.value}</span>
            </div>
            <div className='bp-summary-item'>
                <label>Clock In Time</label>
                <span>{props.clockIn ? formateTimeZone(props.clockIn as any) : '--'}</span>
            </div>
            <div className='bp-summary-item'>
                <label>Clock Out Time</label>
                <span>{props.clockOut ? formateTimeZone(props.clockOut as any) : '--'}</span>
            </div>
            <div className='bp-summary-item'>
                <label>Working Hour</label>
                <span>{props.workingHours || '--'}</span>
            </div>
        </div>
    )
}

export default BpCountSummary
